module.exports = __webpack_public_path__ + "static/media/boat-top.594550af.svg";